// recordCardStyles.js
// Shared surface styling for the pedigree record-surfaces refresh. Both the
// sidebar record card (NoteTile) and the Browse all records card (RecordCard)
// derive their tint from this helper so the two surfaces can never drift.
//
// NOTE: the brief specified this as recordCardStyles.ts, but this repo has no
// TypeScript toolchain (no tsconfig, no typescript dep, zero .ts files), so it
// is authored as .js with the helper logic kept verbatim (only the type
// annotations removed). Runtime behaviour is identical.

// Feature flag for the whole record-surfaces change set (sidebar content grey +
// field states, and the record-card tint on both surfaces). With it off, the
// sidebar and the Browse all records view render exactly as before.
// Rolled ON 2026-07-11 (Tim). Once confirmed stable in the app, REMOVE this flag
// and every `surfaces` branch rather than leaving a long-lived dead style branch.
export const PEDIGREE_RECORD_SURFACES = true;

// Sidebar surface tokens (no equivalent theme token exists; audited). Kept here
// so the surface refresh has a single home alongside the card-tint helper.
export const SURFACE_GREY = '#fafbfc'; // sidebar content region: near-white so the tinted record cards pop
export const FIELD_BORDER = '#d5dbe1'; // resting editable field border
export const READONLY_FILL = '#e7ebef'; // read-only / disabled field fill, kept a clear step darker than SURFACE_GREY

// Reproductive accent — the pregnancy tiles' left bar, and the subject chip on a prenatal event in a
// person's Clinical Records. Shared so the two surfaces that mark reproductive data cannot drift to
// different pinks.
export const PREG_ACCENT = '#c2185b';

export const RECORD_CARD_TINT_ALPHA = 0.075;

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  const full =
    h.length === 3
      ? h
          .split('')
          .map((c) => c + c)
          .join('')
      : h;
  const n = parseInt(full, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

/** Low-opacity tint background derived from a category accent colour. */
export function recordCardTint(accentHex, alpha = RECORD_CARD_TINT_ALPHA) {
  const [r, g, b] = hexToRgb(accentHex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Faint border to pair with the tint. */
export function recordCardTintBorder(accentHex) {
  const [r, g, b] = hexToRgb(accentHex);
  return `rgba(${r}, ${g}, ${b}, 0.20)`;
}
